/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * type of payment
 * @export
 */
export const PaymentType = {
    Sepa: 'SEPA',
    Invoice: 'INVOICE',
    Paypal: 'PAYPAL',
    Giropay: 'GIROPAY',
    Card: 'CARD',
    Sofort: 'SOFORT',
    Free: 'FREE'
} as const;
export type PaymentType = typeof PaymentType[keyof typeof PaymentType];


export function PaymentTypeFromJSON(json: any): PaymentType {
    return PaymentTypeFromJSONTyped(json, false);
}

export function PaymentTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentType {
    return json as PaymentType;
}

export function PaymentTypeToJSON(value?: PaymentType | null): any {
    return value as any;
}

